<div id="consent">
  <h1>
    {{ 'rspConsentHeading' | translate }}
  </h1>
  <div class="consent-information" [innerHTML]="'rspConsentInformation' | translate"></div>

  @let isConsentCheckboxInvalid = consentForm.controls?.['hasGivenConsent'].invalid && consentForm.controls?.['hasGivenConsent'].touched;

  <form class="needs-validation" [formGroup]="consentForm" (ngSubmit)="giveConsent()">
    <div>
      <label for="consent-checkbox" class="form-check-label">
        <input
          id="consent-checkbox"
          class="form-check-input"
          type="checkbox"
          formControlName="hasGivenConsent"
          aria-required="true"
          [class.is-invalid]="isConsentCheckboxInvalid"
          [attr.aria-invalid]="consentForm.controls?.['hasGivenConsent'].invalid"
        />
        {{ 'rspConsentCheckbox' | translate }}
      </label>
    </div>
    <div class="consent-buttons d-flex justify-content-between">
      <div aria-live="polite" class="mt-0">
        @if (isConsentCheckboxInvalid) {
          <p class="rsp-invalid-form-feedback invalid-feedback d-block m-0" [innerHTML]="'rspFormInvalid' | translate"></p>
        } @else {
          <p class="rsp-invalid-form-feedback invisible m-0"></p>
        }
      </div>
      <button
        id="give-consent"
        class="btn btn-primary"
        type="submit"
        [attr.aria-disabled]="consentForm.invalid"
        [disabled]="consentForm.invalid && isDisableable"
      >
        {{ 'rspConsentButtonContinue' | translate }}
      </button>
    </div>
  </form>
</div>
